import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"
import _imports_0 from '../../../assets/img/icon-arrow-right-active.svg'


const _hoisted_1 = { class: "page-wrapper full-height" }
const _hoisted_2 = { class: "page-wrapper__inner" }
const _hoisted_3 = { class: "data-container" }
const _hoisted_4 = { class: "page-content" }
const _hoisted_5 = { class: "page-content__inner" }
const _hoisted_6 = {
  key: 0,
  class: "happy-sad-report-score-none"
}
const _hoisted_7 = {
  key: 1,
  class: "happy-sad-report-score-low"
}
const _hoisted_8 = {
  key: 2,
  class: "happy-sad-report-score-mid"
}
const _hoisted_9 = {
  key: 3,
  class: "happy-sad-report-score-high"
}
const _hoisted_10 = { class: "td-button" }
const _hoisted_11 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackLink = _resolveComponent("BackLink")!
  const _component_MenuBar = _resolveComponent("MenuBar")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BackLink, { url: "/reporting" }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_MenuBar, {
              searchText: _ctx.searchText,
              hideFilters: true,
              hideSort: true
            }, null, 8, ["searchText"]),
            _createVNode(_component_Table, {
              keyProp: "id",
              rows: _ctx.data
            }, {
              head: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Manager"),
                  _createElementVNode("th", null, "Feedback"),
                  _createElementVNode("th", { class: "hidden-sm text-center" })
                ], -1)
              ]))]),
              default: _withCtx(({ row, index }) => [
                _createElementVNode("tr", {
                  class: _normalizeClass(["row", {
                    alternate: _ctx.isOdd(index),
                  }])
                }, [
                  _createElementVNode("td", null, _toDisplayString(row.firstName) + " " + _toDisplayString(row.surname), 1),
                  _createElementVNode("td", null, [
                    (_ctx.feedbackScores[row.id] === -1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, " This manager has received no feedback yet "))
                      : _createCommentVNode("", true),
                    (
                        _ctx.feedbackScores[row.id] >= 0 &&
                        _ctx.feedbackScores[row.id] <= 33
                      )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.feedbackScores[row.id]) + "% ", 1))
                      : _createCommentVNode("", true),
                    (
                        _ctx.feedbackScores[row.id] > 33 &&
                        _ctx.feedbackScores[row.id] <= 66
                      )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.feedbackScores[row.id]) + "% ", 1))
                      : _createCommentVNode("", true),
                    (_ctx.feedbackScores[row.id] > 66)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.feedbackScores[row.id]) + "% ", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_10, [
                    _cache[2] || (_cache[2] = _createTextVNode(" View ", -1)),
                    (_ctx.feedbackScores[row.id] !== -1)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_11, [...(_cache[1] || (_cache[1] = [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: "",
                            style: {"height":"14px","width":"7px"}
                          }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ], 2)
              ]),
              _: 1
            }, 8, ["rows"]),
            _createVNode(_component_Pagination, {
              currentPage: _ctx.paginationDetails?.pageNumber ?? 1,
              totalRows: _ctx.paginationDetails?.total ?? 0,
              onChangePage: _ctx.handleChangePage,
              onChangeRowCount: _ctx.handleChangeRowCount
            }, null, 8, ["currentPage", "totalRows", "onChangePage", "onChangeRowCount"])
          ])
        ])
      ])
    ])
  ]))
}